import { adTechLog } from '../../general/log';

export const googletagRefresh = ( slots = [] ) => {

	if ( ! slots.length ) {

		// Refresh the slots and dont record anything.
		adTechLog( {
			type: 'info',
			message: 'All slots refreshed.',
		} )

		window.googletag.cmd.push( function() {
			window.googletag.pubads().refresh();
		} );

		return;
	}

	let slotsToRefreshGoogleTag = [];
	let slotsToRefresh = []

	for ( const slot of slots ) {
		// Gather the googletag slots.
		slotsToRefreshGoogleTag.push( slot.id );
		slotsToRefresh.push( slot.slot );
	}

	adTechLog( {
		type: 'info',
		message: `Selected slots refreshed.`,
		details: {
			slotsToRefreshGoogleTag
		}
	} )

	window.googletag.cmd.push( function() {
		window.googletag.pubads().refresh( slotsToRefresh );
	} );

}